export default function SubmitButton({ loading, status, onSubmit }) {
  return (
    <button
      disabled={loading}
      onClick={onSubmit}
      className={`px-8 py-4 rounded text-white ${
        loading ? "bg-gray-500" : "bg-indigo-900"
      }`}
    >
      {loading
        ? "Processing..."
        : status === "draft"
        ? "Save Draft"
        : status === "published"
        ? "Publish Blog"
        : "Schedule Blog"}
    </button>
  );
}
